export const MASKING_LOGIC_CLAUSE_SELECTOR = 'Masking logic - Clause selector'
export const MASKING_LOGIC_QUESTION_SELECTOR =
  'Masking logic - Question selector'
export const DELETE_LOGIC_STATEMENT = 'Delete logic statement'
export const MASKING_LOGIC_NEGATION = 'Masking logic - Negation'
export const EMPTY_QUESTION_ID = 'empty_question_id'
